module.exports = __webpack_public_path__ + "img/chevron-right.1de2f74a.svg";